__turbopack_context__.v({
  "Footer3": "footer3-module__qXiLdq__Footer3",
  "Landing__14": "footer3-module__qXiLdq__Landing__14",
  "Landing__14__Footer": "footer3-module__qXiLdq__Landing__14__Footer",
  "Landing__14__Footer__Content": "footer3-module__qXiLdq__Landing__14__Footer__Content",
  "footer_bg": "footer3-module__qXiLdq__footer_bg",
  "tinyFooter": "footer3-module__qXiLdq__tinyFooter",
});
